import { useTranslation } from 'react-i18next';
import '../PaymentPage.css';

export type LoadingState = 'redirecting' | 'validating' | 'processing';

interface WebpaymentLoadingProps {
  state?: LoadingState;
  language?: string;
  /** CSS class for the outer wrapper. Defaults to 'payment-container'. */
  containerClassName?: string;
}

const TITLE_KEYS: Record<LoadingState, string> = {
  redirecting: 'webpayment.loading.redirecting_title',
  validating:  'webpayment.loading.validating_title',
  processing:  'webpayment.loading.processing_title',
};

const DESC_KEYS: Record<LoadingState, string> = {
  redirecting: 'webpayment.loading.redirecting_description',
  validating:  'webpayment.loading.validating_description',
  processing:  'webpayment.loading.processing_description',
};

export function WebpaymentLoading({
  state = 'validating',
  language,
  containerClassName = 'payment-container',
}: WebpaymentLoadingProps) {
  const { t } = useTranslation();
  const tr = (key: string) => t(key, { lng: language });

  return (
    <div className={containerClassName}>
      <div className="payment-content">
        <div className="loading-spinner" />
        <h2>{tr(TITLE_KEYS[state])}</h2>
        <p>{tr(DESC_KEYS[state])}</p>
      </div>
    </div>
  );
}
